import React from 'react';
import ModalModule from '../modal';
import Utils from '../utils';

const { Modal, ModalButtonActionType } = ModalModule;
const { Navigation } = Utils;

const AccountBalanceLimitModal = ({ modalId, data: { maxPostageBalance } }) => (
	<Modal
		modalId={modalId}
		className="common-payment account-balance-limit-modal"
		header="Account Balance Limit"
		primaryButton={{
			text: 'Change Plan',
			type: ModalButtonActionType.Ok,
			onClick: () => Navigation.navigateTo('storeChangePlan'),
		}}
	>
		{`The maximum account balance for your current plan is ${maxPostageBalance}.
		To add funds to your account, you will need to reduce the fund amount or raise your limit by
		upgrading your membership plan. Current Plan Maximum Meter Balance:
		${maxPostageBalance}.`}
	</Modal>
);
export default AccountBalanceLimitModal;
